"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimezoneOffset = void 0;
var TimezoneOffset = /** @class */ (function () {
    function TimezoneOffset(offset) {
        this.stringOffset = '';
        this.numberOffset = NaN;
        switch (typeof offset) {
            case 'string':
                try {
                    this.stringOffset = offset;
                    this.numberOffset = this.str2num(offset);
                }
                catch (e) {
                    console.error('Error parsing timezone offset:', e.timezoneError);
                }
                break;
            case 'number':
                try {
                    this.stringOffset = this.num2str(offset);
                    this.numberOffset = offset;
                }
                catch (e) {
                    console.error('Error parsing timezone offset:', e.timezoneError);
                }
                break;
            default:
                console.error('Invalid timezone offset type (string|number):', offset);
                break;
        }
    }
    TimezoneOffset.prototype.str2num = function (stringOffset) {
        var _a = TimezoneOffset.re.exec(stringOffset), operand = _a[1], hours = _a[2], minutes = _a[3];
        var numberOffset = (parseInt(minutes, 10) + 60 * parseInt(hours, 10)) * ((operand === '+') ? 1 : -1);
        if (isNaN(numberOffset)) {
            throw { timezoneError: stringOffset };
        }
        return numberOffset;
    };
    TimezoneOffset.prototype.num2str = function (numberOffset) {
        var operand = (numberOffset >= 0) ? '+' : '-';
        var hours = '' + Math.abs(Math.floor(numberOffset / 60));
        if (hours.length === 1) {
            hours = '0' + hours;
        } // padding
        var minutes = '' + Math.abs(numberOffset % 60);
        if (minutes.length === 1) {
            minutes = '0' + minutes;
        } // padding
        var stringOffset = operand + hours + ':' + minutes;
        if (!TimezoneOffset.re.test(stringOffset)) {
            throw { timezoneError: numberOffset };
        }
        return stringOffset;
    };
    TimezoneOffset.re = /([+-])(\d{2}):?(\d{2})/;
    return TimezoneOffset;
}());
exports.TimezoneOffset = TimezoneOffset;
